import { render, staticRenderFns } from "./MCalendar.vue?vue&type=template&id=1881b292"
import script from "./MCalendar.vue?vue&type=script&lang=js"
export * from "./MCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports